import { useEffect } from 'react';

import { useLocalization } from '../i18n/LocalizationProvider';
import { useTranslations } from '../i18n/TranslationsProvider';
import { PageProps } from '../sanity/types';
import { useSiteSettings } from './SiteSettingsProvider';
import { useStoreConfig } from './StoreConfigProvider';

export const useInitLocalizationAndSiteSettings = (props: PageProps) => {
	const {
		site,
		storeConfig,
		translations,
		languages,
		pageOptions: { locale },
	} = props;

	const { setSiteSettings } = useSiteSettings();
	const { setStoreConfig } = useStoreConfig();
	const { setTranslations, setLocale } = useTranslations();
	const { setLanguages } = useLocalization();

	useEffect(() => {
		setSiteSettings(site);
		setStoreConfig(storeConfig ?? null);
		setTranslations(translations);
		setLocale(locale);
		setLanguages({
			availableLanguages: languages?.availableLanguages,
		});
	}, [
		setSiteSettings,
		site,
		setStoreConfig,
		storeConfig,
		setTranslations,
		translations,
		locale,
		setLocale,
		setLanguages,
		languages,
	]);
};
